import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { ThemeProvider } from "@material-ui/styles";
import App from "./containers/App";
import theme from "./helpers/theme";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import configureStore from "./redux/configureStore";

const store = configureStore();

const appProvider = (
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <App />
    </Provider>
  </ThemeProvider>
);

ReactDOM.render(appProvider, document.getElementById("root"));
serviceWorker.unregister();
